export default __webpack_public_path__ + "static/media/Resume.92a698d4.pdf";